<template>

    <div class="gradebook gradebook_teacher">
        <div class="gradebook__header">
            <div class="form-group row">
                <label class="col-form-label text-md-right col-md-2">On date (monday)</label>
                <div class="col-md-9">
                    <div class="input-group input-group--custom">
                        <div class="input-group-addon"><i class="fa fa-clock-o"></i></div>
                        <datetime
                            :value="on_date_c"
                            :config="configDatePicker"
                            >
                        </datetime>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <br>
            <div class="table-reports" v-if="all_days">
                <table class="table is_middle table-condensed table-bordered">
                    <tr>
                        <td></td>
                        <td v-for="day in all_days">{{day.week_day_name}}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td v-for="day in all_days">{{day.date}}</td>
                    </tr>
                    <tr v-for="(time, index) in data_table">
                        <td>{{index}}</td>
                        <td  v-for="group in time" :style="{ 'background-color': group.color }">{{group.value}}</td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="gradebook__main">
            <div class="spiner_gradebook" v-if="submiting" style="width:100%; display:flex; justify-content: center; align-items: center;">
                <img src="/img/spiner.gif" alt="spiner" width="150" height="auto" style="object-fit: contain">
            </div>
        </div>
        <div class="gradebook_mane" :class="{ disable: submiting }"></div>
    </div>

</template>


<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import axios from "axios";

export default {
    name: "TeacherShadule",
    props: ['all_days','table', 'select_date'],
    components: { datetime: flatPickr },
    data() {
        return {
            submiting: false,
            academy: null,
            teacher: null,
            on_date: null,
            data_table: null,
            teachers: [],
            data_schedule: null,
            configDatePicker : {
                locale: { firstDayOfWeek : 1 },
                disable: [
                    function(date) {
                        return ([0,2,3,4,5,6].includes( date.getDay()));
                    }
                ],
                onChange: (dateObj, dateStr) => {
                    this.getTeachers(dateStr);
                },
            }
        }
    },
    computed: {
        on_date_c: {
            get: function () {
                return this.select_date
            },
            set: function (newValue) {
                return newValue;
            }
        }
    },
    mounted() {
            this.data_table = this.table;
    },
    methods: {

        async getTeachers(on_date){
            this.teacher = null;
            const { data: { all_days, data_table, select_date } } = await axios.get('/teacher/dashboard/schedule?on_date=' + on_date);
            this.on_date_c = select_date;
            this.all_days = all_days;
            this.data_table = data_table;
        }
    }
}
</script>
